export const YEAR = "year";
export const PDC_NO = "pdcNumber";
export const PDC_AMOUNT = "pdcAmount";
export const PDC_DATE = "pdcDate";
export const PDC_AMOUNT_RECEIVED = "pdcAmountReceived";
export const PDC_CLEARED_DATE = "pdcClearedDate";
export const PDC_REMARKS = "pdcRemarks";
export const PDC_STATUS = "pdcStatus";


export const pdcStatusOptions = [
  { label: "Recieved", value: "true" },
  { label: "Not Received", value: "false" },
];